import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWind = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4902 14.0303H17.4454H4.62748C4.2689 14.0303 4 14.3215 4 14.6578C4 14.9938 4.29124 15.2852 4.62748 15.2852H17.3782C18.1177 15.2852 18.7004 15.8902 18.7004 16.6074C18.7004 17.3244 18.0954 17.9296 17.3782 17.9296C16.6835 17.9296 16.1009 17.3918 16.056 16.6971C16.0337 16.3385 15.72 16.0922 15.3837 16.1145C15.0251 16.1368 14.7787 16.4506 14.8011 16.7868C14.8908 18.1538 16.0335 19.2069 17.4005 19.2069C18.8347 19.2069 20 18.0416 20 16.6074C20 15.2179 18.8796 14.0751 17.4902 14.0303H17.4902Z",
			fill: "#256F94",
			stroke: "#256F94",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.64969 11.9919H17.4454H17.4902C18.8796 11.9471 20 10.8043 20 9.39244C20 7.95827 18.8347 6.79297 17.4005 6.79297C16.0335 6.79297 14.8907 7.84624 14.8011 9.21306C14.7787 9.57165 15.0476 9.86287 15.3837 9.88538C15.7423 9.90772 16.0335 9.63882 16.056 9.30273C16.1009 8.60804 16.6835 8.07027 17.3782 8.07027C18.1177 8.07027 18.7004 8.67524 18.7004 9.39244C18.7004 10.1095 18.0954 10.7146 17.3782 10.7146H4.6497C4.29111 10.7146 4.02222 11.0059 4.02222 11.3421C4.02239 11.6782 4.29129 11.9919 4.6497 11.9919H4.64969Z",
			fill: "#256F94",
			stroke: "#256F94",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5099 8.67488H12.0224C13.0308 8.67488 13.8599 7.84569 13.8599 6.83744C13.8599 5.82901 13.0532 5 12.0447 5C11.619 5 11.1932 5.15687 10.8571 5.44811C10.5882 5.67216 10.5659 6.07559 10.7899 6.3445C10.9245 6.47904 11.1037 6.56856 11.2605 6.56856C11.4174 6.56856 11.5518 6.52371 11.664 6.41168C11.7312 6.3445 11.8657 6.27715 12.0226 6.27715C12.3363 6.27715 12.5827 6.52371 12.5827 6.83729C12.5827 7.15104 12.3361 7.39744 12.0226 7.39744L6.51005 7.39761C6.15146 7.39761 5.88257 7.68885 5.88257 8.0251C5.88257 8.36118 6.15147 8.67491 6.51005 8.67491L6.5099 8.67488Z",
			fill: "#256F94",
			stroke: "#256F94",
			strokeWidth: .5
		})
	]
});
export default SvgWind;
